import React, { useRef, useState } from 'react';

export default function ImageResizer({
    defaultValue,
    previewSize = [100, 80],
    width = 320, height = 240,
    type = 'image/png', onChange = (uri) => { } }) {
    const [resizedImage, setResizedImage] = useState(null);
    const fileInputRef = useRef();

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                const dataUrl = canvas.toDataURL(type); // or 'image/png'
                setResizedImage(dataUrl);
                onChange(dataUrl)
            };
            img.src = event.target.result;
        };
        reader.readAsDataURL(file);
    };
    let cssBox = { backgroundColor: '#2ea37d1a', padding: 10, borderRadius: 8 }
    return (
        <div style={cssBox}>
            <input type="file" accept="image/*" onChange={handleFileChange} ref={fileInputRef} />
            <span style={{ fontSize: '12px', color: 'gray' }}>
                File size should not exceed 5MB
            </span>
            <div style={{ display: 'flex', gap: 3, marginTop:4 }}>
                {resizedImage && (
                    <div>
                        <p>Resized Image ({width}×{height}):</p>
                        <img src={resizedImage} alt="Resized" width={previewSize[0]} height={previewSize[1]} />

                    </div>
                )}
                {(!resizedImage && defaultValue) && <div> <img src={defaultValue} alt="Resized" width={previewSize[0]} height={previewSize[1]} /></div>}
            </div>
        </div>
    );
}
